import type { ExamDetails } from "../types";

const fetchExams = async (
	_tenantId: string,
	_appId: string,
): Promise<ExamDetails[]> => {
	return [];
};

export { fetchExams };
